export default __webpack_public_path__ + "d24fcca8e01928335b8b0a747cfe37be3c887f4395bc95e191f4a0a2a413f32b.svg";